"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _fission = require("@/api/activity/fission");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FissionScalperWhitelistPane',
  data: function data() {
    return {
      listLoading: false,
      querying: false,
      saving: false,
      syncing: false,
      clearing: false,
      memberFound: false,
      tableData: [],
      total: 0,
      searchForm: {
        page: 1,
        limit: 10,
        userId: '',
        mobile: '',
        cardNo: ''
      },
      dialogVisible: false,
      form: {
        userId: '',
        mobile: '',
        cardNo: '',
        remark: ''
      }
    };
  },
  created: function created() {
    this.fetchList();
  },
  methods: {
    fetchList: function fetchList() {
      var _this = this;
      this.listLoading = true;
      var params = _objectSpread({}, this.searchForm);
      if (params.userId === '') delete params.userId;
      (0, _fission.queryScalperWhitelistPage)(params).then(function (res) {
        var data = res.data || res;
        _this.tableData = data.records || data.list || [];
        _this.total = data.total || 0;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: 10,
        userId: '',
        mobile: '',
        cardNo: ''
      };
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.fetchList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.fetchList();
    },
    resetForm: function resetForm() {
      this.form = {
        userId: '',
        mobile: '',
        cardNo: '',
        remark: ''
      };
      this.memberFound = false;
    },
    buildMemberQuery: function buildMemberQuery() {
      var params = {};
      if (this.form.userId) params.userId = this.form.userId;
      if (this.form.mobile) params.mobile = this.form.mobile;
      if (this.form.cardNo) params.cardNo = this.form.cardNo;
      if (!params.userId && !params.mobile && !params.cardNo) {
        return null;
      }
      return params;
    },
    handleQueryMember: function handleQueryMember() {
      var _this2 = this;
      var params = this.buildMemberQuery();
      if (!params) {
        this.$message.warning('用户ID/手机号/卡号至少填一项');
        return;
      }
      this.querying = true;
      this.memberFound = false;
      (0, _fission.queryScalperWhitelistMember)(params).then(function (res) {
        var member = res && res.data || res || {};
        if (!member.userId) {
          _this2.$message.error('此会员不存在');
          return;
        }
        _this2.form.userId = member.userId;
        _this2.form.mobile = member.mobile || '';
        _this2.form.cardNo = member.cardNo || '';
        _this2.memberFound = true;
      }).finally(function () {
        _this2.querying = false;
      });
    },
    handleSave: function handleSave() {
      var _this3 = this;
      if (!this.form.userId && !this.form.mobile && !this.form.cardNo) {
        this.$message.warning('用户ID/手机号/卡号至少填一项');
        return;
      }
      this.saving = true;
      var payload = {
        userId: this.form.userId ? Number(this.form.userId) : null,
        mobile: this.form.mobile || null,
        cardNo: this.form.cardNo || null,
        remark: this.form.remark || null
      };
      (0, _fission.addScalperWhitelist)(payload).then(function () {
        _this3.$message.success('保存成功');
        _this3.dialogVisible = false;
        _this3.fetchList();
      }).finally(function () {
        _this3.saving = false;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm('确认删除该白名单记录？', '提示', {
        type: 'warning'
      }).then(function () {
        return (0, _fission.deleteScalperWhitelist)(row.id);
      }).then(function () {
        _this4.$message.success('已删除');
        _this4.fetchList();
      }).catch(function () {});
    },
    handleSyncScalper: function handleSyncScalper() {
      var _this5 = this;
      this.$confirm('从 CDP 拉取黄牛名单并写入 Redis（覆盖当前缓存，永不过期），确认同步？', '同步黄牛名单', {
        type: 'warning'
      }).then(function () {
        _this5.syncing = true;
        return (0, _fission.syncScalperCache)();
      }).then(function (res) {
        _this5.$message.success(res && res.message || '同步成功');
      }).catch(function () {}).finally(function () {
        _this5.syncing = false;
      });
    },
    handleClearScalper: function handleClearScalper() {
      var _this6 = this;
      this.$confirm('将清除 Redis 中的黄牛名单。请在活动结束后再操作，确认清除？', '清除黄牛数据', {
        type: 'warning'
      }).then(function () {
        _this6.clearing = true;
        return (0, _fission.clearScalperCache)();
      }).then(function (res) {
        _this6.$message.success(res && res.message || '已清除');
      }).catch(function () {}).finally(function () {
        _this6.clearing = false;
      });
    }
  }
};